// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"06abb0a6","734":"c2f3fca8"}[chunkId] + ".js";
};